module.exports = __webpack_public_path__ + "static/img/maintain.9311ce8a.png";